// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.height-100vh {
  height: 100vh !important;
}

.width-auto {
  width: auto !important;
}

.min-height-100vh {
  min-height: 100vh !important;
}

.min-height-80vh {
  min-height: 80vh !important;
}

.min-height-60vh {
  min-height: 60vh !important;
}

.max-height-100vh {
  max-height: 100vh !important;
}

.width-100 {
  width: 100% !important;
}

.width-90 {
  width: 90% !important;
}

.height-100 {
  height: 100% !important;
}

.max-height-200px {
  max-height: 200px !important;
}

.min-height-100px {
  min-height: 100px;
}

.height-inherit {
  height: inherit !important;
}

.height-40 {
  height: 40px !important;
}

.width-40 {
  width: 40px !important;
}

.height-50 {
  height: 50px !important;
}

.width-50 {
  width: 50px !important;
}

.height-100px {
  height: 100px !important;
}

.max-height-100px {
  max-height: 100px !important;
}

.width-100px {
  width: 100px !important;
}

.card-dimension {
  width: 100px !important;
  height: 100px !important;
}

.height-fit-content {
  height: fit-content !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/dimension.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,sBAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,sBAAA;AAAF;;AAGA;EACE,wBAAA;AAAF;;AAGA;EACE,4BAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,wBAAA;AAAF;;AAGA;EACE,8BAAA;AAAF","sourcesContent":[".height-100vh {\n  height: 100vh !important;\n}\n\n.width-auto {\n  width: auto !important;\n}\n\n.min-height-100vh {\n  min-height: 100vh !important;\n}\n\n.min-height-80vh {\n  min-height: 80vh !important;\n}\n\n.min-height-60vh {\n  min-height: 60vh !important;\n}\n\n.max-height-100vh {\n  max-height: 100vh !important;\n}\n\n.width-100 {\n  width: 100% !important;\n}\n\n.width-90 {\n  width: 90% !important;\n}\n\n.height-100 {\n  height: 100% !important;\n}\n\n.max-height-200px {\n  max-height: 200px !important;\n}\n\n.min-height-100px {\n  min-height: 100px;\n}\n\n.height-inherit {\n  height: inherit !important;\n}\n\n\n.height-40 {\n  height: 40px !important;\n}\n\n.width-40 {\n  width: 40px !important;\n}\n\n.height-50 {\n  height: 50px !important;\n}\n\n.width-50 {\n  width: 50px !important;\n}\n\n.height-100px {\n  height: 100px !important;\n}\n\n.max-height-100px {\n  max-height: 100px !important;\n}\n\n.width-100px {\n  width: 100px !important;\n}\n\n.card-dimension {\n  width: 100px !important;\n  height: 100px !important;\n}\n\n.height-fit-content {\n  height: fit-content !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
